var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgPecas = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    d: "M11.8817 9.38013L1.62405 19.6212C1.28125 19.9489 1.06471 20.3869 1.01235 20.8583C0.959994 21.3297 1.07516 21.8044 1.33769 22.1995C1.50169 22.4307 1.7142 22.6234 1.96038 22.7641C2.20656 22.9047 2.48048 22.99 2.763 23.0138C3.04552 23.0376 3.32985 22.9995 3.59611 22.9021C3.86238 22.8047 4.10417 22.6503 4.30461 22.4498C4.30461 22.4498 14.6294 12.125 14.6207 12.1181C15.6513 12.6143 16.8049 12.7972 17.9384 12.644C19.072 12.4908 20.1356 12.0083 20.9976 11.2564C21.8596 10.5044 22.4819 9.51609 22.7875 8.41382C23.0932 7.31155 23.0686 6.14383 22.7169 5.05539C22.6913 4.97503 22.6454 4.90259 22.5838 4.845C22.5222 4.78741 22.4468 4.7466 22.3649 4.72646C22.283 4.70633 22.1973 4.70755 22.116 4.73001C22.0348 4.75247 21.9606 4.79541 21.9006 4.85474L18.0171 8.73726C17.9638 8.79078 17.8986 8.83115 17.827 8.85515C17.7553 8.87916 17.679 8.88615 17.6041 8.87557L15.7963 8.61745C15.6919 8.60246 15.5953 8.554 15.5208 8.47935C15.4463 8.4047 15.3981 8.30789 15.3833 8.20348L15.1242 6.39567C15.1135 6.32089 15.1204 6.24465 15.1442 6.17298C15.168 6.1013 15.2082 6.03615 15.2616 5.98267L19.1451 2.09918C19.2044 2.03916 19.2473 1.96492 19.2697 1.88357C19.2921 1.80222 19.2932 1.71648 19.273 1.63456C19.2527 1.55264 19.2118 1.47729 19.1541 1.41573C19.0964 1.35416 19.0239 1.30844 18.9434 1.28293C17.8549 0.931333 16.6872 0.90689 15.5849 1.21264C14.4827 1.51838 13.4944 2.14087 12.7426 3.00295C11.9907 3.86503 11.5084 4.92879 11.3554 6.06238C11.2023 7.19597 11.3853 8.34955 11.8817 9.38013Z",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgPecas;